module.exports = __webpack_public_path__ + "assets/img/9.356484e1.png";